/**
 * The state flag files' own pixel sizes, read from each served PNG's header on
 * 10/16/2026 (/state-flags/fridge.com-<code>-flag.png, 51 files: the 50 states
 * and DC; 16 different shapes, from 1.14 to 2.0 wide per tall).
 *
 * FRIDGE-1540: a lazy flag drawn at a fixed width with `height: auto` counts in
 * Chromium as an image without explicit dimensions (LazyLoadImageIssue: 406 on
 * production 10/15/2026), and its height came from the file only once it
 * loaded. `stateFlagStyle()` gives the flag its own aspect ratio inline, so its
 * box has the file's shape before it loads and the drawing is unchanged; the
 * `object-fit: contain` keeps a replaced file of another shape from stretching.
 * A code with no entry keeps the old behaviour.
 */
const STATE_FLAG_SIZES: Readonly<Record<string, readonly [number, number]>> = {
  ak: [640, 452],
  al: [640, 427],
  ar: [640, 427],
  az: [640, 427],
  ca: [640, 427],
  co: [640, 427],
  ct: [640, 504],
  dc: [1200, 600],
  de: [640, 427],
  fl: [640, 427],
  ga: [640, 400],
  hi: [640, 320],
  ia: [640, 428],
  id: [640, 504],
  il: [640, 384],
  in: [640, 427],
  ks: [640, 384],
  ky: [640, 337],
  la: [640, 414],
  ma: [640, 384],
  md: [640, 427],
  me: [640, 504],
  mi: [640, 427],
  mn: [640, 384],
  mo: [640, 373],
  ms: [640, 384],
  mt: [640, 427],
  nc: [640, 427],
  nd: [640, 504],
  ne: [640, 384],
  nh: [640, 427],
  nj: [640, 385],
  nm: [640, 427],
  nv: [640, 427],
  ny: [640, 320],
  oh: [640, 394],
  ok: [640, 427],
  or: [640, 427],
  pa: [640, 467],
  ri: [640, 562],
  sc: [640, 427],
  sd: [640, 400],
  tn: [640, 384],
  tx: [640, 427],
  ut: [640, 384],
  va: [640, 427],
  vt: [640, 384],
  wa: [640, 381],
  wi: [640, 427],
  wv: [640, 337],
  wy: [640, 448],
}

export function stateFlagStyle(code: string | null | undefined): { aspectRatio: string; objectFit: 'contain' } | undefined {
  const size = STATE_FLAG_SIZES[(code || '').toLowerCase()]
  return size ? { aspectRatio: `${size[0]} / ${size[1]}`, objectFit: 'contain' } : undefined
}

/** The same, from a flag's path (`/state-flags/fridge.com-<code>-flag.png`), for components handed only the URL. */
export function stateFlagStyleForSrc(src: string | null | undefined): ReturnType<typeof stateFlagStyle> {
  const code = /\/state-flags\/fridge\.com-([a-z]{2})-flag\.png/.exec(src || '')?.[1]
  return stateFlagStyle(code)
}
